import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { ENUMS, VISIONS } from '../../../../../utils/constants';
import ListPagination from '../../../../../components/UI/ListPaginationUl';
import * as pabReplanningAction from '../../../../../actions/pabReplanningAction';
import PABReplanningService from '../../../../../services/PABReplanningService';
import PickingService from '../../../../../services/PickingService';
import { translate } from '../../../../../utils/util';
import { getVision } from '../../../../../services/auth';
import BackButton from '../../../../../components/UI/BackButton';

const ListMission = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [orders, setOrdes] = useState([]);

    useEffect(() => {
        if (props.orders?.items) {
            const pendingList = props.orders.items.filter((m) => (m.status === ENUMS.eOrderStatus.Waiting.value || m.status === ENUMS.eOrderStatus.InProgress.value)
                && m.items.filter((i) => i.status === ENUMS.eOrderItemStatus.Waiting.value || i.status === ENUMS.eOrderItemStatus.InProgress.value).length > 0);
            setOrdes(pendingList);
        }
        // eslint-disable-next-line
    }, [props.orders.items, props.orderReceived.updateListMission]);

    const onSelectChange = (item) => {
        const mission = item?.items?.find(o => o.status === ENUMS.eOrderItemStatus.Waiting.value || o.status === ENUMS.eOrderItemStatus.InProgress.value);
        var order = item;
        props.setSelectedOrder(order);
        props.startOrder(order.orderId);
        props.startOrderItem(mission.orderId, mission.orderItemId, () => {
            props.history.push({
                pathname: `/pabReplanning/smallParts/order/missions/${mission.orderItemId}`
            });
            props.setSelectedMission(mission);
        });
    }

    const onPutOnHold = (selectedItem) => {
        props.changeStatusOrder(selectedItem.orderId, ENUMS.eOrderStatus.OnHold.value, () => {
            props.updateOrder(selectedItem.orderId);
        });
    };

    const leave = () => {
        if (props.order.orderGroupId > 0) {
            props.leave(props.order.orderGroupId, false)
        }

        return props.history.replace({
            pathname: `/pabReplanning/smallParts`
        });
    }

    return (
        <div>
            <BackButton {...props} onClick={() => leave()} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="subtitle">
                        <i className="material-icons">compare_arrows</i>
                        Grupo {orders[0]?.orderGroupId || ''}
                    </div>
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '40px' }}>
                <div id="listOrdersMission">
                    <ListPagination
                        page={0}
                        current={{ currentPage, setCurrentPage }}
                        data={orders.map((item) => (
                            <>
                                {
                                    (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && item.status !== ENUMS.eOrderStatus.OnHold.value &&
                                    <span
                                        className="title sixth-text-color right"
                                        style={{ position: 'absolute', marginTop: '0px', right: '45px' }}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            if (onPutOnHold) {
                                                onPutOnHold(item);
                                            }
                                        }}
                                    ><i className="material-icons medium">pause_circle_outline</i>
                                    </span>
                                }
                                <div
                                    className="row"
                                    style={{ display: 'block', marginBottom: '0px', marginLeft: '0px' }}
                                    onClick={() => {
                                        onSelectChange(item);
                                    }}
                                >
                                    <span className="title sixth-text-color" style={{ display: 'block' }} >
                                        {item?.items[0]?.partnumber || ''}
                                    </span>
                                    <div className="title sixth-text-color">
                                        {item?.items[0]?.location || ''}
                                    </div>
                                    <div className="col s12 second-text-color"  >
                                        {item?.items[0]?.orderItemCode || ''}
                                    </div>

                                    <div style={{ paddingRight: '10px' }}>
                                        <div className="col s4 truncate second-text-color" style={{ display: 'block', paddingRight: '0px', paddingleft: '0px' }}>
                                            {translate('line-picking:linepicking.route')}: {item?.route?.code || ''}
                                        </div>
                                        <div className="col s4 truncate second-text-color" style={{ paddingRight: '0px', paddingleft: '0px' }}>
                                            {translate('line-picking:linepicking.amount')}: {item?.items[0]?.quantity || ''}
                                        </div>
                                        <div className="col s4 truncate second-text-color" style={{ paddingRight: '0px', paddingleft: '0px' }}>
                                            {translate('line-picking:linepicking.mdr')}: {item?.items[0]?.mdrType || ''}
                                        </div>

                                    </div>

                                </div>
                            </>
                        ))}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        mission: state.pabReplanningReducer.mission,
        order: state.pabReplanningReducer.order,
        orders: state.pabReplanningReducer.orders,
        orderReceived: state.pabReplanningReducer.orderReceived,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedOrder: (order) => {
            dispatch(pabReplanningAction.selectOrder(order));
        },
        setSelectedMission: (mission) => {
            dispatch(pabReplanningAction.selectMission(mission));
        },
        startOrder: (orderId, callback) => {
            dispatch(PABReplanningService.startOrder(orderId, callback));
        },
        startOrderItem: (orderId, orderItemId, callback) => {
            dispatch(PABReplanningService.startOrderItem(orderId, orderItemId, callback));
        },
        changeStatusOrder: (orderId, status, callback) => {
            dispatch(PickingService.changeStatusOrder(orderId, status, callback));
        },
        updateOrder: (orderId) => {
            dispatch(pabReplanningAction.removeOrder(orderId));
        },
        leave: (orderGroupId, abandon) => {
            dispatch(PABReplanningService.leave(orderGroupId, abandon));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListMission)));
